import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Puis-je bénéficier du crédit d'impôt de 50 % ?",
    a: "Ma demande d'agrément « Services à la Personne » est en cours auprès de l'URSSAF. Dès qu'il est accordé, mes livraisons à domicile ouvriront droit à un crédit d'impôt de 50 % : une livraison à 8 € ne vous coûtera réellement que 4 €. Je l'annoncerai sur le site dès que c'est officiel.",
  },
  {
    q: "Quelle zone couvrez-vous ?",
    a: "Je livre au départ d'Illzach, dans un rayon d'environ 20 km : Mulhouse, Kingersheim, Wittenheim, Riedisheim, Rixheim, Sausheim et toutes les communes voisines. Et si plusieurs voisins commandent ensemble, je vais volontiers plus loin — appelez-moi au 06 73 31 82 36.",
  },
  {
    q: "Comment se passe le paiement ?",
    a: "Comme vous préférez : carte bancaire en ligne au moment de la réservation, espèces à la livraison, ou virement bancaire. Vous pouvez aussi avancer le montant de vos courses dans le formulaire pour tout régler en une fois.",
  },
  {
    q: "Quel poids ou volume pouvez-vous transporter ?",
    a: "Jusqu'à une vingtaine de kilos : deux ou trois sacs de courses, un colis volumineux, un bouquet. Au-delà, je vous le confirme au téléphone avant de valider.",
  },
  {
    q: "Puis-je réserver pour un parent âgé ?",
    a: "Bien sûr, c'est même une grande partie de mes livraisons. Indiquez ses coordonnées et son adresse : je l'appelle pour confirmer et je vous tiens informé une fois livré.",
  },
  {
    q: "Et en cas d'urgence ?",
    a: "Appelez-moi directement au 06 73 31 82 36, du lundi au vendredi de 8h à 17h et le samedi de 8h à 16h. Si je suis disponible, je peux intervenir dans les deux heures.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-10 text-center"
        >
          <span className="mb-4 inline-flex w-fit rounded-full bg-forest/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-forest">
            Questions fréquentes
          </span>
          <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Tout ce qu'on me demande <em className="italic text-terra">souvent</em>
          </h2>
        </motion.div>

        <div className="divide-y divide-ink/10 rounded-3xl bg-cream p-2 ring-1 ring-ink/5">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-question-${i}`}
                  className="flex min-h-[56px] w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-semibold text-ink transition-colors hover:text-forest sm:text-lg"
                >
                  {item.q}
                  <ChevronDown className={`h-5 w-5 shrink-0 text-terra transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 pb-5 text-base leading-relaxed text-ink/70">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
